import type { PropsWithChildren, ReactElement } from 'react';

import type { ButtonProps } from '@mui/material/Button';

import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';

import { useGlobalState } from '../../../../../global_state/src';

type ThemedProgressDialogButtonProps = PropsWithChildren<ButtonProps>;

const ThemedProgressDialogButton = ({
    children,
    ...buttonProps
}: ThemedProgressDialogButtonProps): ReactElement => {
    const [theme] = useGlobalState('theme');

    return (
        <ThemeProvider theme={theme}>
            <Button {...buttonProps}>{children}</Button>
        </ThemeProvider>
    );
};

export { ThemedProgressDialogButton };
export type { ThemedProgressDialogButtonProps };
